import Icon from 'src/common/ui-kit/Icon/Icon'
import clsx from 'clsx'
import { PropsWithChildren } from 'react'

export interface ExternalLinkProps {
  link: string
  iconSize?: string | number
  iconPosition?: 'left' | 'right'
  hideIcon?: boolean
  className?: string
  iconClassName?: string
}

const ExternalLink: React.FC<PropsWithChildren<ExternalLinkProps>> = ({
  link,
  iconSize = 20,
  children,
  hideIcon = false,
  iconPosition = 'left',
  className = '',
  iconClassName,
}) => {
  const baseClasses = clsx(
    'flex items-center gap-2',
    {
      'flex-row': iconPosition === 'left',
      'flex-row-reverse': iconPosition === 'right',
    },
    className
  )

  return (
    <a className={baseClasses} href={link} target='_blank'>
      {!hideIcon && (
        <Icon
          cursor='pointer'
          name='external-link'
          width={iconSize}
          height={iconSize}
          className={iconClassName}
        />
      )}
      {children}
    </a>
  )
}

export default ExternalLink
